export const phoneToHref = (phone) => `tel:${phone.replace(/ /g, "")}`;

export const smsToHref = (number, message) => `sms:${number.replace(/ /g, "")}&body=${message}`;

export const concordanceByLength = (length, singular, plural) => (length > 1 ? plural : singular);

export const capitalize = (text = "") =>
  text?.toLowerCase().replace(/(^\w{1})/g, (match) => match.toUpperCase());

export const normalizeText = (value) => (value ? value : "--");

export const isEmpty = (value) => !!value && value.trim().length > 0;

export function hiddenEmail(email) {
  if (!email) {
    return "";
  }

  const parts = email.split("@");
  const name = parts[0];
  let result = name.charAt(0);

  for (let i = 1; i < name.length; i++) {
    result += "*";
  }

  result += name.charAt(name.length - 1);
  result += "@";

  const domain = parts[1];
  result += domain.charAt(0);
  const dot = domain.indexOf(".");

  for (let i = 1; i < dot; i++) {
    result += "*";
  }

  result += domain.substring(dot);

  return result;
}

export const formatName = (text = "") =>
  text.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (match) => match.toUpperCase());

export default function trimStart(str) {
  if (str === null) return str;
  return str.replace(/^\s+/g, "");
}
